// (function(){
//   function loadSwiper(cb){
//     if (window.Swiper) return cb();
//     var s = document.createElement('script');
//     s.src = "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js";
//     s.onload = cb;
//     document.head.appendChild(s);
//   }

//   function enhanceMobileSliders(){
//     var grids = document.querySelectorAll('.x-mobile-swiper[data-mobile-swiper="true"]');
//     grids.forEach(function(grid){
//       var bp = parseInt(grid.getAttribute('data-breakpoint') || '768', 10);
//       var isMobile = window.matchMedia('(max-width:'+(bp-1)+'px)').matches;

//       if (isMobile && !grid.classList.contains('why-swiper')){
//         var wrap = document.createElement('div');
//         wrap.className = 'swiper-wrapper';
//         Array.from(grid.children).forEach(function(card){
//           var slide = document.createElement('div');
//           slide.className = 'swiper-slide';
//           slide.appendChild(card);
//           wrap.appendChild(slide);
//         });
//         var container = document.createElement('div');
//         container.className = 'swiper why-swiper';
//         container.appendChild(wrap);
//         var pag = document.createElement('div');
//         pag.className = 'swiper-pagination';
//         container.appendChild(pag);
//         grid.appendChild(container);

//         grid.__swiper = new Swiper(container, {
//           slidesPerView: 1.05,
//           spaceBetween: 16,
//           centeredSlides: false,
//           pagination: { el: pag, clickable: true }
//         });
//       }

//       if (!isMobile && grid.classList.contains('why-swiper')){
//         if (grid.__swiper){ grid.__swiper.destroy(true, true); grid.__swiper = null; }
//         var swiper = grid.querySelector('.swiper');
//         if (swiper){
//           var frag = document.createDocumentFragment();
//           swiper.querySelectorAll('.swiper-slide').forEach(function(slide){
//             if (slide.firstElementChild) frag.appendChild(slide.firstElementChild);
//           });
//           swiper.remove();
//           grid.appendChild(frag);
//         }
//       }
//     });
//   }

//   function init(){
//     loadSwiper(function(){
//       enhanceMobileSliders();
//       window.addEventListener('resize', (function(fn, w){ var t; return function(){ clearTimeout(t); t=setTimeout(fn,w); }; })(enhanceMobileSliders, 150), { passive: true });
//     });
//   }

//   if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
//   else init();
// })();
document.addEventListener('DOMContentLoaded', function () {
  
  function syncDisabled(swiper, prevEl, nextEl) {
    const atStart = swiper.isBeginning;
    const atEnd = swiper.isEnd;
    prevEl?.classList.toggle('disabled', atStart);
    nextEl?.classList.toggle('disabled', atEnd);
    prevEl?.setAttribute('aria-disabled', String(atStart));
    nextEl?.setAttribute('aria-disabled', String(atEnd));
  }
  
  document.querySelectorAll('.custom-swiper-buttons').forEach(function (wrap) {
    const targetSelector = wrap.getAttribute('data-target') || wrap.getAttribute('data-traget') || '';
    const targetRoot = targetSelector ? document.querySelector(targetSelector) : wrap.closest('[data-mobile-swiper="true"]') || document;
    if (!targetRoot) return;
    
    const swiperEl =
      targetRoot.querySelector('.swiper') ||
      targetRoot.querySelector('.x-swiper-container') ||
      targetRoot.closest('.swiper');

    if (!swiperEl) return;
    const swiper = swiperEl.swiper || (swiperEl.querySelector('.swiper')?.swiper);
    if (!swiper) return;

    const prevBtn = wrap.querySelector('.x-swiper-button-prev');
    const nextBtn = wrap.querySelector('.x-swiper-button-next');
    
    // Get transition speed from swiper or default to 300
    const speed = swiper.params?.speed || 300;
    
    prevBtn?.addEventListener('click', function (e) {
      e.preventDefault();
      const targetIndex = Math.max(0, swiper.activeIndex - 1);
      swiper.slideTo(targetIndex, speed);
      
      // Force snap after transition should be complete
      setTimeout(function() {
        swiper.slideTo(targetIndex, 0);
        swiper.update();
      }, speed + 50);
    });
    
    nextBtn?.addEventListener('click', function (e) {
      e.preventDefault();
      const totalSlides = swiper.slides?.length || 1;
      const targetIndex = Math.min(totalSlides - 1, swiper.activeIndex + 1);
      swiper.slideTo(targetIndex, speed);
      
      // Force snap after transition should be complete
      setTimeout(function() {
        swiper.slideTo(targetIndex, 0);
        swiper.update();
      }, speed + 50);
    });
    
    function wireBullets() {
      const bullets = swiperEl.querySelectorAll('.swiper-pagination .swiper-pagination-bullet');
      bullets.forEach(function (bullet, index) {
        bullet.addEventListener('click', function (e) {
          e.preventDefault();
          const active = swiper.realIndex ?? swiper.activeIndex ?? 0;

          if (index === active) return;
          
          swiper.slideTo(index, speed);
          
          // Force snap after transition
          setTimeout(function() {
            swiper.slideTo(index, 0);
            swiper.update();
          }, speed + 50);
        }, { passive: false });
      });
    }
    
    wireBullets();
    syncDisabled(swiper, prevBtn, nextBtn);

    swiper.on('slideChange', function () {
      syncDisabled(swiper, prevBtn, nextBtn);
    });
    
    swiper.on('paginationUpdate', function () {
      wireBullets();
    });
    
    const pag = swiperEl.querySelector('.swiper-pagination');
    if (pag) {
      const mo = new MutationObserver(() => wireBullets());
      mo.observe(pag, { childList: true, subtree: true });
    }
  });
});